import { getArtikelNrOhneEigentuemer } from "@/lib/artikelauswahl";
import { webCookie } from "@/lib/cookies";
import { NotificationStyle } from "@/lib/models/notifications";
import { showNotification } from "@/lib/notifications";
import { apiEndpoints, environment } from "@/lib/resources";
import $ from "jquery";

const $stepButton = $("#step-free-download-button");

//Step-Download request
$stepButton.on("click", async e => {
	e.preventDefault();

	let data: any = await $.ajax({
		type: "POST",
		url: apiEndpoints.downloadStep,
		data: {
			artikelnummer: getArtikelNrOhneEigentuemer(),
			profileId: webCookie.id,
			identityCulture: environment.identityCulture,
		},
	})
		.catch((_httpRequest, _textStatus, errorThrown) => showNotification(NotificationStyle.Error, errorThrown));

	if (data.fehler) {
		showNotification(NotificationStyle.Error, data.status);
		return;
	}

	window.location.href = data.downloadUrl;
});

export function showStepDownload(visible: boolean) {
	$stepButton.toggle(visible);
}
